import React from "react";
import { SiLinkedin } from "react-icons/si";
import { VscGithub } from "react-icons/vsc";
import { FaUniversity } from "react-icons/fa";
import { BsTwitter } from "react-icons/bs";

export default class HeaderSocials extends React.Component {
	render() {
		return (
			<div className="header_socials">
				<a
					href="https://www.linkedin.com/in/syntax-read3r/"
					target="_blank"
					rel="noopener noreferrer"
				>
					<SiLinkedin className="icon" />
				</a>
				<a
					href="https://twitter.com/munyaChikara"
					target="_blank"
					rel="noopener noreferrer"
				>
					<BsTwitter className="icon" />
				</a>

				<a
					href="https://github.com/Syntax-Read3r"
					target="_blank"
					rel="noopener noreferrer"
				>
					<VscGithub className="icon" />
				</a>
				<a
					href="https://techeducators.co.uk/blog/munya-chikara"
					target="_blank"
					rel="noopener noreferrer"
				>
					<FaUniversity className="icon" />
				</a>
			</div>
		)
	}
}